module.exports = __webpack_public_path__ + "static/media/fuji-logo.f667d1a7.png";